// extracted by mini-css-extract-plugin
export var addViewLink = "_n-1";
export var availabilityIcon = "_n-16";
export var availabilitySelectionIcon = "_n-15";
export var backButton = "_n-2";
export var backIcon = "_n-z";
export var conversationCount = "_n-3";
export var dragHandle = "_n-5";
export var dropdown = "_n-e";
export var dropdownIcon = "_n-7";
export var dropdownOption = "_n-6";
export var dropdownTriangle = "_n-d";
export var expand = "_n-f";
export var folder = "_n-i";
export var folderItem = "_n-c";
export var icon = "_n-8";
export var iconRow = "_n-9";
export var image = "_n-a";
export var logo = "_n-b";
export var navContainer = "_n-h";
export var navigationFooter = "_n-g";
export var pageShell = "_n-0";
export var placeholderAvailable = "_n-11";
export var placeholderBox = "_n-14";
export var placeholderBusy = "_n-13";
export var placeholderUnavailable = "_n-12";
export var profile = "_n-k";
export var profileContainer = "_n-m";
export var profileDropdown = "_n-n";
export var profileImage = "_n-l";
export var profileMain = "_n-o";
export var profileSubtitle = "_n-q";
export var profileTitle = "_n-p";
export var reorderIcon = "_n-r";
export var sentLine = "_n-u";
export var settingsHeader = "_n-s";
export var sidenavTextColor = "_n-y";
export var spamLine = "_n-t";
export var subitemWithTag = "_n-4";
export var supportItems = "_n-j";
export var teamText = "_n-10";
export var viewLine = "_n-x";
export var viewLineButton = "_n-w";
export var viewLineButtons = "_n-v";